<template>
  <div class="rating-stars">
    <div class="review--score">
      <abbr
        :title="title"
        class="star-rating-representation"
      >
        <span
          v-for="(star,index) in maxStars"
          :key="index"
          :class="[star<=stars ? 'fa-star' : 'fa-star-outline']"
        />
      </abbr>
    </div>
    <span class="score--value"><abbr :title="title">{{ rating }}/{{ maxStars }}</abbr></span>
  </div>
</template>
<script>
export default {
  name: 'ReviewRatingStars',
  props: {
    rating: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      maxStars: 10,
    };
  },
  computed: {
    title() {
      return `${this.rating}/${this.maxStars} Star Review Rating.`;
    },
    stars() {
      return Math.round(this.rating);
    },
  },
  methods: {},
};
</script>

<style scoped>
  .rating-stars{
    display: flex;
    align-items: center;
  }
  .star-rating-representation{
    display: flex;
    align-items: center;
  }
  .review--score{
    height: auto;
    vertical-align: middle;
  }
</style>
